module.exports = __webpack_public_path__ + "static/media/swimmy-story-pool-mobile.dd991ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swimmy-story-pool-mobile.png
// module id = 2496
// module chunks = 0